module.exports = __webpack_public_path__ + "static/media/bonds.4a9bc6fa.svg";